export default withScroll;

function withScroll() {
    this.scrollToElement = function(element) {
        this.scrollTo(element.offset().top);
    };

    this.scrollIntoView = function(element) {
        if (!this.elementOnScreen(element)) {
            this.scrollItemToBottomOfView(element);
        }
    };

    this.scrollItemToBottomOfView = function(element) {
        var innerHeight = window.innerHeight || document.documentElement.clientHeight;
        this.scrollTo(element.offset().top + element.height() - innerHeight);
    };

    this.scrollToUnlessVisible = function(element) {
        if (!this.elementOnScreen(element)) {
            this.scrollTo(element.offset().top);
        }
    };

    this.scrollTo = function(position) {
        $('html,body').animate({ scrollTop: position }, 500);
    };

    // Test if an element is entirely on screen
    this.elementOnScreen = function(el) {
        if (el instanceof $) {
            el = el[0];
        }
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight ||
                    document.documentElement.clientHeight) /*or $(window).height() */ &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/mixins/with-scroll.js